import React from 'react'
import { AppRouteURI, AppRoutingRoles } from 'router/RoleBasedAccess'
import App from '../../../components/app/App'
import SevenScreen from 'pages/Dashboard/HomeSevenScreen/SevenScreen'
import Main from './7screen/Main'

export default () => {
    const { isProtected, checkRoles } = { ...AppRoutingRoles[AppRouteURI.HOME] }
    return (
        <App
            isProtected={isProtected}
            checkRoles={checkRoles}
            showSideBar={false}
            isSevenScreen={true}
        >
            <Main></Main>
        </App>
    )
}
